import React, { useState } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { CONST_AIR, CONST_SUBWAY, CONST_BASEMENT, CONST_FACADE, CONST_LOFT, CONST_AIR_INTERHOUSE, CONST_AIR_PILLAR} from '../../../Optics/Constants/ConstantsOptics';
import { TerritoryLabel } from '../../../Optics/Dialog/DialogDescriptionComponent/TerritoryLabel ';
import CableDescriptEditingModal from './DescriptionEditingModal/CableDescriptEditingModal';

const CableDescriptConstruction = ({ open, onClose, content, snackbarOpen, snackbarMessage, snackbarClass,
  handleCloseSnackbar, copyToClipboard, changeLinkEditing, cantonRefresh, cantonCablaByIdRefresh}) => {

  const [openModalEditing, setOpenModalEditing] = useState(false);
 
  const openModalEditingContent = () => {
     setOpenModalEditing(true);
  };

  return (
    <Dialog open={open} className="dialogStyle">    
    <DialogContent>
    <img src='./cable.png' width='30' height='30' style={{marginRight: "5px"}}/>
    <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset', textShadow: '2px 2px 4px rgb(61, 61, 61)'}}>Информация о кабеле</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold',textShadow: '2px 2px 4px #4e4e4e' }}>ID: <span style={{ color: '#bebebe', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.id}</span></label>
      <Button 
          style={{marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
          onClick={() => { copyToClipboard(content.id, "кабель"); }}>
          <FileCopyIcon style={{ color: '#e4c253'}}/>
        </Button>
       <br/>
     <TerritoryLabel  content={content} />
      <hr className='horizontalLineDialog2'/>
       
        <label style={{ color: '#292929', fontWeight: 'bold' }}>
           Признак: 
           <span style={{ color: content.ether === 1 || content.pon === 1 || content.ktv === 1 ? '#bdab6f' : '#de858e', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>
             {[
                content.pon === 1 && ' PON',
                content.ktv === 1 && ' KTV',
                content.ether === 1 && ' Ethernet'
             ]
              .filter(Boolean) 
             .join(', ') || ' Нет'}
           </span>
        </label>
        <br />
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Кабель: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)'}}>{content.cableName}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Количество волокон: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.cableFiberQuantity}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Тип: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.cableTypeType}</span></label>
      <br/>
       {content.forwardingCount !=0 && (
        <>
         <label style={{ color: '#292929', fontWeight: 'bold'}}>Пробросов: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.forwardingCount}</span></label>
        <br/>
        </>
       )}
      {content.cableTypeType === CONST_SUBWAY && (
          <>
           <hr className='horizontalLineDialog2'/>          
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Длина (акт приема): <span style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.lengthAct} м.</span></label>
            <br />
          </>
        )}
       {[CONST_AIR_INTERHOUSE, CONST_AIR_PILLAR, CONST_BASEMENT, CONST_FACADE, CONST_LOFT].includes(content.cableTypeType) && (
          <>
           <hr className='horizontalLineDialog2'/>
                 
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Длина (факт): <span style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}> {content.lengthAct || 0} м.</span></label>
            <br />
          </>
        )}
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Длина кабеля: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.lengthCable} м.</span></label>
     
          {content.cassetteCount != 0 && (
          <> 
            <br/> 
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Кассета: <span style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.cassetteModel} ( {content.cassetteCount} шт.)</span></label>
          
          </>
        )}
         {content.patchCount != 0 && (
          <>
              <br />     
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Патчкорд: <span style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.polishingType} ( {content.patchCount} шт.)</span></label>
            <br />
          </>
        )}


      <hr className='horizontalLineDialog2'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Принадлежность к узлам: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.rankCableName}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Подрядчик: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.contractorName}</span></label>
      <br/>
     
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}> {new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.description}</span></label>
      <hr className='horizontalLineDialog2'/>
      
    </DialogContent>

    <DialogActions>
    
      <Button onClick={openModalEditingContent} class='buttonIsEditDialog'>
          Редактировать
        </Button>
        
      <Button onClick={onClose} class='buttonIsHideDrawer23'>
        Закрыть
      </Button>
    </DialogActions>

     {/* Snackbar */}
     <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={4000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

       
      {/* Modal редактирование CableCanton*/}
      <CableDescriptEditingModal
        open={openModalEditing}
        onClose={() => setOpenModalEditing(false)}
        onClose2={onClose}
        content={content}
        changeLinkEditing={changeLinkEditing}
        cantonRefresh={cantonRefresh}
        cantonCablaByIdRefresh={cantonCablaByIdRefresh}
      /> 
     
   </Dialog>
  );
}

export default CableDescriptConstruction;